import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash'
import VueLocalStorage from 'vue-localstorage'
import { notificationSetup } from "../util/notifications";

Vue.use(VueLocalStorage)
Vue.use(Router)

//  Payment
const Signup = () => import("../view/signup/Signup.vue");
const UploadIdCard = () => import("../view/signup/UploadIdCard.vue");
const Dashboard = () => import("../view/dashboard/Dashboard.vue");
const Appointments = () => import("../view/appointments/Appointments.vue");
const DoctorDetailsView = () => import("../view/appointments/DoctorDetailsView.vue");
const PhysioDetailsView = () => import("../view/appointments/PhysioDetailsView.vue");
const NurseDetailsView = () => import("../view/appointments/NurseDetailsView.vue");
const LabtechDetailsView = () => import("../view/appointments/LabtechDetailsView.vue");
const Profile = () => import("../view/profile/Profile.vue");
const Schedule = () => import("../view/schedule/Schedule.vue");
const Accounts = () => import("../view/accounts/Accounts.vue");
const Notification = () => import("../view/notification/Notification.vue");
const ContactUs = () => import("../view/contactus/Contactus.vue");
// const Reports = () => import("../view/reports/Reports.vue");
const Settings = () => import("../view/settings/Settings.vue");
const PrivacyPolicy = () => import("../view/privacypolicy/PrivacyPolicy.vue");
const RateandReview = () => import("../view/rateandreview/RateAndReview.vue");
const TermsAndConditions = () => import("../view/terms/TermsAndConditions.vue");
const ChatWithDoctorView = () => import("../view/chat/ChatWithDoctorView.vue");
const AddDiagnosisView = () => import("../view/appointments/diagnosis/AddDiagnosisView.vue");
const ReviewDiagnosis = () => import("../components/appointments/diagnosis/ReviewDiagnosis.vue");
const Prescription = () => import("../view/appointments/diagnosis/prescription/Prescription.vue");
const AddProductMedicine = () => import("../../src/components/appointments/diagnosis/prescription/AddProductMedicine.vue");
const PreviousPrescription = () => import("../../src/components/appointments/PreviousPrescription.vue");
const PrimaryDiagnosis = () => import("../../src/components/appointments/diagnosis/PrimaryDiagnosis.vue");
const TreatmentReferral = () => import("../view/appointments/diagnosis/treatment-referral/TreatmentReferral.vue");
const SickLeave = () => import("../view/appointments/diagnosis/sick-leave/SickLeave.vue");
const Error404 = () => import("../components/common/Error404.vue");
const NetworkError = () => import("../components/common/NetworkError.vue");
const PageNotFound = () => import("../components/common/PageNotFound.vue");
const Reportsv1 =()=> import("../view/reportsv1/Reportsv1.vue");
const Families =()=> import("../view/familydoctors/Families.vue");
const FamilyMembers =()=> import("../view/familydoctors/FamilyMembers.vue");
const MyAppointments=()=>import("../view/nurse/MyAppointments.vue");
const AppointmentBookingDetails=()=>import("../view/nurse/AppointmentBookingDetails.vue");
const CompletedDetails=()=>import("../view/nurse/CompletedDetails.vue");
const LabTechnician=()=>import("../view/lab-technician/LabTechnician.vue");
import { pro_url } from "../../config/endpoints";
const router = new Router({
  mode: "history",
  routes: [
    { path: "/", name: 'signup', component: Signup },
    { path: "/upload-id-card", name: 'upload-id-card', component: UploadIdCard },
    { path: "/dashboard", name: 'dashboard', component: Dashboard },
    { path: "/appointments", name: 'appointments', component: Appointments },
    { path: "/appointments/doctor-details/:appid?", name: 'doctor-details', component: DoctorDetailsView },
    { path: "/profile", name: 'profile', component: Profile },
    { path: "/schedule", name: 'schedule', component: Schedule },
    { path: "/accounts", name: 'accounts', component: Accounts },
    { path: "/notification", name: 'notification', component: Notification },
    { path: "/contactus", name: 'contactus', component: ContactUs },
    // { path: "/reports", name: 'reports', component: Reports },
    { path: "/reportsv1", name: 'reportsv1', component: Reportsv1 },
    { path: "/settings", name: 'settings', component: Settings },
    { path: "/privacy-policy", name: 'privacy-policy', component: PrivacyPolicy },
    { path: "/rate-and-review", name: 'rate-and-review', component: RateandReview },
    { path: "/terms-and-conditions", name: 'terms-and-conditions', component: TermsAndConditions },
    { path: "/appointments/chat-with-a-doctor/:appid?", name: 'chat-with-a-doctor', component: ChatWithDoctorView },
    { path: "/appointments/doctor-details/add-diagnosis/:appid?", name: 'add-diagnosis', component: AddDiagnosisView },
    { path: "/appointments/doctor-details/review-diagnosis/:appid?", name: 'review-diagnosis', component: ReviewDiagnosis },
    { path: "/appointments/doctor-details/add-diagnosis/add-prescription/:appid?", name: 'add-prescription', component: Prescription },
    { path: "/appointments/doctor-details/add-diagnosis/add-product-medicine/:appid?", name: 'add-product-medicine', component: AddProductMedicine },
    { path: "/appointments/doctor-details/previous-prescription/:appid?", name: 'previous-prescription', component: PreviousPrescription },
    { path: "/appointments/doctor-details/add-diagnosis/add-problems/:appid?", name: 'add-problem', component: PrimaryDiagnosis },
    { path: "/appointments/doctor-details/add-diagnosis/treatment-referral/:appid?", name: 'treatment-referral', component: TreatmentReferral },
    { path: "/appointments/doctor-details/add-diagnosis/sick-leave/:appid?", name: 'sick-leave', component: SickLeave },
    { path: "/appointments/physio-details/:appid?", name: 'physio-details', component: PhysioDetailsView },
    { path: "/appointments/nurse-details/:appid?", name: 'nurse-details', component: NurseDetailsView },
    { path: "/appointments/labtech-details/:appid?", name: 'labtech-details', component: LabtechDetailsView },
    { path: "/404-error", name: '404-error', component: Error404 },
    { path: "/network-error", name: 'network-error', component: NetworkError },
    { path: "/page-not-found", name: 'page-not-found', component: PageNotFound },
    { path: "/Families", name: 'Families', component: Families },
    { path: "/family-members", name: 'FamilyMembers', component: FamilyMembers },
    { path: "/my-appointments", name: 'MyAppointments', component: MyAppointments },
    { path: "/new-booking-details", name: 'AppointmentBookingDetails', component: AppointmentBookingDetails },
    { path: "/completed-details", name: 'CompletedDetails', component: CompletedDetails },
    { path: "/lab-technician", name: 'LabTechnician', component: LabTechnician },
    { path: '*', redirect: '/' },
  ]
})

router.beforeResolve(async (to, from, next) => {
  if (to.query.token) {
    let token = decodeURIComponent(to.query.token)
    let refreshToken = decodeURIComponent(to.query.refreshToken)
    Vue.localStorage.set('token', token)
    Vue.localStorage.set('refresh_token', refreshToken)
    let tokenData = await checkAPPToken(token)
      if (tokenData && tokenData.status == '1000') {
        Vue.localStorage.set("userdata", JSON.stringify(tokenData.userData), 60 * 60 * 2 + 55)
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
        }, 1000);
        return next()
      } else {
        Vue.localStorage.remove('token')
        return next({ path: '/' })
      }
  } else {
    let token = ''
    if (Vue.localStorage.get('token')) {
      token = Vue.localStorage.get('token')
    }
    if (to.path == '/' && token) {
      let tokenCheck = await checkToken()
      if (tokenCheck && tokenCheck.status == '1000') {
        // notificationSetup()
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
        }, 1000);
        return next({ path: "/dashboard", name: 'dashboard' })
      } else {
        Vue.localStorage.remove('token')
        return next({ path: '/' })
      }
    } else if (to.path == '/' && !token) {
      setTimeout(function () {
        router.app.$store.dispatch("SET_LAYOUT", to.name);
      }, 1000);
      return next()
    } else if (!token) {
      setTimeout(function () {
        router.app.$store.dispatch("SET_LAYOUT", 'Signup');
      }, 1000);
      return next({ path: '/' })
    } else {
      setTimeout(function () {
        router.app.$store.dispatch("SET_LAYOUT", to.name);
      }, 1000);
      return next()
    }
  }
})

function checkToken () {
    return router.app.$store.dispatch('httpGet', {
      uri: `${pro_url}/refreshToken`
  })
}

function checkAPPToken (token) {
  return router.app.$store.dispatch('httpGet', {
    uri: `${pro_url}/refreshToken`,
    token: token
})
}
export default router
